Pegasus.ToolbarController = Ember.ObjectController.extend({
  _selectedList: function(){
    return this.get('selectableContactLists').
      filterProperty('id', this.get('dataFormListId') ).
      get('firstObject');
  }.property().volatile(),

  errorMsgAI: '',
  isLoadingFromAI: false,
  isLoadedFromAI: false,
  responseTextAI: '',
  textareaValue: '',
  copiedToClipboard: false,
  placeholderTextarea: Em.I18n.t('instructions.provide_brief_description'),

  copyToClipboard() {
    var $temp = $("<textarea>");
    var brRegex = /<br\s*[\/]?>/gi;
    $("body").append($temp);
    $temp.val(this.get('responseTextAI').replace(brRegex, "\r\n")).select();
    document.execCommand("copy");
    $temp.remove();
  },

  copyFromAI: function() {
    this.copyToClipboard();
    this.set('copiedToClipboard', true);

    var self = this;
    setTimeout(function() {
      self.set('copiedToClipboard', false);
    }, 1000);
  },

  sendToAI: function() {
    var requestStr = $(".ai-content-generator .ember-text-area").val().trim();

    if (requestStr.length === 0) {
      this.set('errorMsgAI', Em.I18n.t('instructions.empty_request'));
      return;
    }
    this.set('errorMsgAI', '');

    var context = this;
    context.set('isLoadingFromAI', true);
    context.set('isLoadedFromAI', false);

    var blackseaHost = localStorage.getItem('blacksea_host');
    var blackseaToken = localStorage.getItem('blacksea_token');
    var userId = localStorage.getItem('user_id');
    var headers = {
      'Authorization': 'Bearer ' + blackseaToken,
      'X-blacksea-user': userId,
      'Access-Control-Allow-Headers': '*'
    };
    var url = blackseaHost + '/v1/ai/content';

    $.ajax({
      type: 'POST',
      url:  url,
      headers: headers,
      data: {
        "question": requestStr
      },
      success: function( res, xhr ) {
        var responseText = res.data.answer;
        context.set('responseTextAI', responseText);
        context.set('isLoadingFromAI', false);
        context.set('isLoadedFromAI', true);
      },
      error: function(xhr) {
        context.set('isLoadingFromAI', false);
        var errMsg = xhr.status === 401 ? Em.I18n.t('instructions.error_401') : Em.I18n.t('instructions.error_response');

        context.set('errorMsgAI', errMsg);
      }
    });
  },

  selectedList: function(_,value){
    if ( typeof(value) !== 'undefined') {
      if ( value ) {
        this.set('dataFormListId', value.id);
        return value;
      } else {
        this.set('dataFormListId', '');
        return {};
      }
    }

    if ( this.get('dataFormListId') ) {
      return this.get('_selectedList');
    }
  }.property('dataFormListId'),

  validatedSuccessActionRedirectURL: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      var self = this;

      import( 'valid-url' ).then(function(lib){
        if ( lib.isUri( value ) ) {
          Em.run( self, 'set', 'successActionRedirectURL', value);
        }
      });

      return value;
    }
    return this.get('successActionRedirectURL');
  }.property('successActionRedirectURL'),

  hasHidden: false,

  intrinsicBreach: function(){
    return this.get('selectedTemplateWidth') < this.get('intrinsicTemplateWidth');
  }.property('selectedTemplateWidth', 'intrinsicTemplateWidth'),

  actions: {
    didChangeText: function(){
      // Trigger a line height adjustment
      var c = Pegasus.lookupController('frameCommManager');
      Em.run(c, 'propertyChanged', this, 'dataLineHeight');
    },
    hideControls: function(){
      Pegasus.stateMachine.send('hideControls');
    },

    textareaChanged: function(value){
      this.set('textareaValue', value);
    },

    textareaClicked: function(value){
      this.set('placeholderTextarea', '');
    },

    alignCloseLeft: function(){
      this.set('selectedCloseAlignment', 'left');
    },

    alignCloseRight: function(){
      this.set('selectedCloseAlignment', 'right');
    },

    alignLeft: function(){
      this.set('dataAlignment', 'left');
    },

    alignCenter: function(){
      this.set('dataAlignment', 'center');
    },

    alignRight: function(){
      this.set('dataAlignment', 'right');
    },

    didCandyToggle: function(data, context) {
      if ( data === 'shadow' ) {
        var newValue = this.get('isShowingShadow') ? false : true;
        this.set('isShowingShadow', newValue);
      }
    },

    selectCloseStyle: function(style) {
      this.set('selectedCloseButton', style);
    },

    selectBorderRadius: function(option) {
      this.set('selectedBorderRadiusOption', option);
    }
  },

  addRow: function(params) {
    Pegasus.lookupController('frameCommManager').send('receiveAddRow', params);
  },

  panelMode: 'Blocks',

  isBorderRadiusNone: function(){
    return this.get('selectedBorderRadiusOption') === 'none';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusTiny: function(){
    return this.get('selectedBorderRadiusOption') === 'tiny';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusSmall: function(){
    return this.get('selectedBorderRadiusOption') === 'small';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusMedium: function(){
    return this.get('selectedBorderRadiusOption') === 'medium';
  }.property('selectedBorderRadiusOption'),

  isSelectedImageEditingFrozen: function(){
    return this.get('selectedIsAnimatedGif') === 'true';
  }.property('selectedIsAnimatedGif'),

  isSelectedBlockRegionImageAnimated: function(){
    return this.get('selectedBlockRegionImageAnimated') === 'true';
  }.property('selectedBlockRegionImageAnimated'),

  isDataBackgroundImageAnimated: function(){
    return this.get('dataBackgroundImageAnimated') === 'true';
  }.property('dataBackgroundImageAnimated'),

  isBorderRadiusLarge: function(){
    return this.get('selectedBorderRadiusOption') === 'large';
  }.property('selectedBorderRadiusOption'),

  isCloseStyleCircleXGray: function(){
    return this.get('selectedCloseButton') === 'circle_x_gray.png';
  }.property('selectedCloseButton'),

  isCloseStyleXGray: function(){
    return this.get('selectedCloseButton') === 'x_gray.png';
  }.property('selectedCloseButton'),

  isCloseStyleXWhite: function(){
    return this.get('selectedCloseButton') === 'x_white.png';
  }.property('selectedCloseButton'),

  successAction: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      if ( value ) {
        this.set('successActionId', value.get('id'));
      }
      return value;
    }
    return this.get('successActions').filterProperty('id', this.get('successActionId')).get('firstObject');
  }.property('successActionId'),

  successActions: function(){
    return [
      Em.Object.create({
        id: '1',
        name: Em.I18n.t(Pegasus.loadedTemplate().get('underscore_type') + '.success_action_one')
      }),
      Em.Object.create({
        id: '2',
        name: Em.I18n.t('g.redirect_to_url')
      })
    ];
  }.property(),

  canDefineTemplateDimensions: function(){
    return this.get('selectedTemplateAppearance') !== 'full_screen';
  }.property('selectedTemplateAppearance'),

  isRedirectSelected: function(){
    return this.get('successActionId') === '2';
  }.property('successActionId'),

  needs: ['editing', 'application', 'themes', 'modal', 'template'],

  selectableContactLists: [],
  errors: {},
  toolbarDescription: '',
  subTabMode: '',
  subTabOneDisplay: '',
  subTabOneMode: '',
  subTabTwoDisplay: '',
  subTabTwoMode: '',

  clearSubTab: function(){
    this.setProperties({
      subTabMode: '',
      subTabOneDisplay: '',
      subTabOneMode: '',
      subTabTwoDisplay: '',
      subTabTwoMode: '',
      toolbarDescription: ''
    });
  },

  showHints: false,

  didChangeContent: function(){
    if ( ! this.get('showHints') ) { return; }

    this.send('setHelpContext', this.get('content.payload.type') );
  }.observes('content.payload.type'),

  content: function(){
    return this.get('controllers.editing.content') || {};
  }.property('controllers.editing.content'),

  edited: function(){
    return this.get('controllers.editing.edited');
  }.property('controllers.editing.edited'),

  editImage: function(){
    Pegasus.stateMachine.send('editImage');
  },

  editText: function(){
    Pegasus.stateMachine.send('editText');
  },

  saveNewList: function(){
    this.send('saveNewContactList', this.get('newListName') );
  },

  saveAndPreview: function(){
    Pegasus.stateMachine.transitionTo('validating.previewing');
  },

  sendTest: function(){
    var blockedFromSendingEmail = Pegasus.get('blockedFromSendEmail');

    if (blockedFromSendingEmail) {
      this.informUserOfBlock();
    }
    else {
      Pegasus.stateMachine.transitionTo('validating.testing');
    }
  }
});

Pegasus.ToolbarController.reopen({
  initialThemeName: null,
  initialEmailDecorationValues: null,

  defaultBackgroundImage: null,
  defaultBackgroundColor: null,
  defaultFontFace: null,
  defaultThemeColor: null,

  initialLogoState: null,

  previousSelectedTheme: null,

  selectedTheme: null,

  imageHandler: function(_, desc) {
    if ( typeof(desc) !== 'undefined' ) {
      if ( desc ) {
        var func = desc.imageCompletionCallback;
        // clear the imageHandler when its completion handler has been called once
        var wrap = function(){
          Em.run( this, 'set', 'imageHandler', null);
          if ( func ) {
            func.apply(null, arguments);
          }
        }.bind(this);
        desc.imageCompletionCallback = wrap;
        return desc;
      }
    }

    return null;
  }.property(),

  didFinishUploading: function(data){
    if ( this.get('imageHandler') ) {
      if(data.encoded){
        this.get('imageHandler.imageCompletionCallback')( data );
      }
    }
  },

  defaultListId: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      Pegasus.lookupController('frameCommManager').propertyChanged(this, 'defaultListId', value);
      return value;
    }
    return '';
  }.property(),

  previousSelectedRowColor: null,

  didReplaceColors: function(map){
    this.set('touched', true);
    Pegasus.lookupController('frameCommManager').send('requestReplaceColors', map);
  }
});

Pegasus.ToolbarController.reopen({
  desiredFooterLabelColor: null,
  desiredFooterAnchorColor: null,
  desiredHeaderColor: null,
  desiredParagraphColor: null,
  desiredRowColor: null,

  clearRows: function(){
    Pegasus.lookupController('frameCommManager').clearTemplateRows();
  }

});

(function(){
  var host = window.location.protocol + '//' + window.location.host;
  var key = '?' + Math.random()*10000000000000000;

  Pegasus.ToolbarController.reopen({
    followIconStyles: [
      {
        group: 'circle',
        sampleImageGroup: 'circle-samples',
        facebookUrl: host + '/pegasus/assets/circle-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/circle-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/circle-youtube.png' + key
      },
      {
        group: 'square',
        sampleImageGroup: 'square-samples',
        facebookUrl: host + '/pegasus/assets/square-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/square-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/square-youtube.png' + key
      },
      {
        group: 'hexagon',
        sampleImageGroup: 'hexagon-samples',
        facebookUrl: host + '/pegasus/assets/hexagon-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/hexagon-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/hexagon-youtube.png' + key
      },
      {
        group: 'circleline',
        sampleImageGroup: 'circleline-samples',
        facebookUrl: host + '/pegasus/assets/circleline-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/circleline-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/circleline-youtube.png' + key
      },
      {
        group: 'hexline',
        sampleImageGroup: 'hexline-samples',
        facebookUrl: host + '/pegasus/assets/hexline-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/hexline-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/hexline-youtube.png' + key
      },
      {
        group: 'graycircle',
        sampleImageGroup: 'graycircle-samples',
        facebookUrl: host + '/pegasus/assets/graycircle-facebook.png' + key,
        twitterUrl: host + '/pegasus/assets/graycircle-twitter.png' + key,
        youtubeUrl: host + '/pegasus/assets/graycircle-youtube.png' + key
      }
    ],

    replaceImage: function(){
      Pegasus.lookupController('application').set('shouldShowImageReplacer', true);
    },

    aviaryEdit: function(tools, isImportContext){
      if( ! this.get('imageHandler.actOnProperty') ) {
        console.error('missing image handler');
        return;
      }

      var maxWidth = this.get('imageHandler.maxImageWidth');

      var src  = this.get( this.get('imageHandler.actOnProperty') ),
        id = 'fake-element', //$("img[src='"+src+"']").attr('id'),
        re = new RegExp(host),
        fake;

      $('#' + id ).remove();

      //Bug in safari which causes the element passed to aviary
      //to become corrupt in some way, which results in a 401
      //unauthorized error when attempting to get the image, caused by cookies
      //not being sent in the request.  The creation
      //of a fake element, fixes the issue.
      var launchAviary = function(src, id){
        $('#' + id ).remove();

        fake = $('<img style="display:none;">');
        fake.appendTo('body');
        fake.attr('id', id);

        fake.imagesLoaded().
          always(function(){
            var bodyClassName = 'vr-resizing';

            $('body').removeClass(bodyClassName);
            if ( isImportContext ) {
              $('body').addClass(bodyClassName);
            }

            Em.run.scheduleOnce( 'afterRender', null, function(){
              Pegasus.loadImageEditor(function(){
                $(window).trigger('imageEditorLoaded');
                window.imageEditor.launch({
                  maxSize: maxWidth,
                  tools: tools || ['enhance', 'effects', 'frames', 'stickers', 'crop', 'resize', 'orientation', 'focus',
                    'brightness', 'contrast', 'saturation', 'sharpness', 'colorsplash', 'text'],
                  onClose: function(){
                    Em.run.next(function(){
                      $('#fake-element').remove();
                    });
                  },
                  noCloseButton: false,
                  image: id
                });
              });
            });
          }).attr('src', src);
      };

      return launchAviary(src, id);
    },

    resizeImage: function(tools, isImportContext){
      if( ! this.get('imageHandler.actOnProperty') ) {
        console.error('missing image handler');
        return;
      }

      var maxWidth = this.get('imageHandler.maxImageWidth');
      var callback = this.get('imageHandler.imageCompletionCallback');

      var src  = this.get( this.get('imageHandler.actOnProperty') ),
        id = 'fake-element', //$("img[src='"+src+"']").attr('id'),
        re = new RegExp(host),
        fake;

      $('#' + id ).remove();

      var self = this;

      var launchAviary = function(src, id){

        var success = function(data){
          $('#' + id ).remove();

          fake = $('<img style="display:none;">').attr('src', data.encoded);
          fake.appendTo('body');
          fake.attr('id', id);

          Em.run.scheduleOnce( 'afterRender', null, function(){
            Pegasus.loadTuiEditor({
              save: callback,
              container: self.container,
              source: src,
              maxSize: maxWidth
            });
          });
        };

        // User images are authenticated resources.
        // Safari won't pass cookies with requests to load Image objects from urls unless
        // use-credentials is set on the image object first.  So, we'll try to load anonymously
        // first and then fail-over to credentialed requests rather than writing a MORE hacky
        // url detection before passing the image to Tui.  It is redundent, but it should be solid.
        var error = function() {
          var reallyBroken = function(){
            window.alert('Image Error');
          };

          window.convertToDataURLviaCanvas(src, success, reallyBroken, 'image/png', 99999, true);
        };

        window.convertToDataURLviaCanvas(src, success, error, 'image/png', 99999, false);
      };

      return launchAviary(src, id);
    },

    isImageEditingFrozen: function(){
      return this.get('dataIsAnimatedGif') === 'true';
    }.property('dataIsAnimatedGif'),

    isLabelFrozen: function(){
      return this.get('dataLabelFrozen') === 'true';
    }.property('dataLabelFrozen'),

    isAlignCloseLeft: function(){
      return this.get('selectedCloseAlignment') === 'left';
    }.property('selectedCloseAlignment'),

    isAlignCloseRight: function(){
      return this.get('selectedCloseAlignment') === 'right';
    }.property('selectedCloseAlignment'),

    isAlignLeft: function(){
      return this.get('dataAlignment') === 'left';
    }.property('dataAlignment'),

    isAlignRight: function(){
      return this.get('dataAlignment') === 'right';
    }.property('dataAlignment'),

    isAlignCenter: function(){
      return !this.get('isAlignLeft') && !this.get('isAlignRight');
    }.property('isAlignLeft', 'isAlignRight'),

    width: function(){
      // returning the width here would be create a responsiveness problem
      return '100%';
    }.property('dataWidth')
  });
})();

Pegasus.ToolbarController.reopen({
  activeField: null
});
